export const MODULE = 'BIRTH_CERTIFICATE_SETTINGS';
export const GET_BIRTH_CERTIFICATE_SETTINGS = `${MODULE}/get_birth_certificate_settings`;
export const SHOW_BIRTH_CERTIFICATE_SETTINGS = `${MODULE}/show_birth_certificate_settings`;
export const CREATE_BIRTH_CERTIFICATE_SETTINGS = `${MODULE}/create_birth_certificate_settings`;
export const UPDATE_BIRTH_CERTIFICATE_SETTINGS = `${MODULE}/update_birth_certificate_settings`;
